import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdAdd,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdCheckCircle,
  MdCloud,
  MdFolder,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Account.css";
import Spinner from "../components/Spinner";
import { useNavigate } from "react-router";
import { isEmpty } from "../functions/isEmpty";

export default function Inbox({
  apiURL,
  isMobile,
  chats,
  scrollPositionHome,
  setScrollPositionHome,
  operators,
  user,
  searchString,
  setSearchString,
  setActiveOperator,
  activeContact,
  setActiveContact,
  activeOperator,
  documents,
  files,
  setFiles,
  customers,
  messages,
  connections,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [emailConnection, setEmailConnection] = useState({});
  const [sortedData, setSortedData] = useState([]);
  let navigate = useNavigate();

  const handleClick = (chats_id, sendername) => {
    let searchedOperatorID = 0;
    let searchedOperator = {};
    if (!isEmpty(sendername)) {
      console.log(sendername);
      setActiveContact(sendername);
    }
    chats.map((chat, index) => {
      if (chat.id == chats_id) {
        searchedOperatorID = chat.operators_id;
      }
    });

    operators.map((operator, index) => {
      if (operator.id == searchedOperatorID) {
        searchedOperator = operator;
      }
    });
    setActiveOperator(searchedOperator);

    navigate("/chats/" + chats_id);
  };

  useEffect(() => {
    connections.map((conn, index) => {
      if (conn.type == "email") {
        setEmailConnection(conn);
        return;
      }
    });
  }, [connections]);

  useEffect(() => {
    const grouped = messages
      .filter((msg) => msg.type == "email")
      .reduce((map, msg) => {
        const key = msg.thirdparty_id; // statt msg.sender
        const ts = Number(msg.createdAt);
        const unseen = msg.seen === 0 ? 1 : 0;

        if (!map.has(key)) {
          map.set(key, { ...msg, notseencount: unseen, ts });
        } else {
          const prev = map.get(key);
          if (ts > prev.ts) {
            map.set(key, {
              ...msg,
              notseencount: prev.notseencount + unseen,
              ts,
            });
          } else {
            prev.notseencount += unseen;
          }
        }
        return map;
      }, new Map());

    const sorted = Array.from(grouped.values())
      .sort((a, b) => b.ts - a.ts)
      .map(({ ts, ...rest }) => rest);

    setSortedData(sorted);
  }, [messages]);

  function formatTimestamp(unixTimestamp) {
    // Überprüfe, ob der Timestamp eine gültige Zahl ist
    if (isNaN(unixTimestamp)) {
      return "";
    }

    const date = new Date(unixTimestamp * 1000); // Unix-Timestamp in Sekunden
    const now = new Date();

    // Prüfe, ob das Datum vom heutigen Tag ist
    if (date.toDateString() === now.toDateString()) {
      // Formatierung: hh:mm
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      return `${hours}:${minutes}`;
    }

    // Berechne den Unterschied in Tagen
    const startOfToday = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const startOfDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
    const diffTime = startOfToday - startOfDate;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    // Wenn genau 1 Tag Unterschied: "gestern"
    if (diffDays === 1) {
      return "Gestern";
    }

    // Liegt die Nachricht zwischen 1 und 6 Tagen zurück?
    if (diffDays < 7) {
      // Deutscher Wochentag
      const weekdays = [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag",
      ];
      return weekdays[date.getDay()];
    } else {
      // Mehr als 7 Tage zurück: Format dd.mm.yy
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear().toString().slice(-2);
      return `${day}.${month}.${year}`;
    }
  }

  useEffect(() => {
    if (isEmpty(user)) {
      let authData = localStorage.getItem("@ditochat_user");
      if (!isEmpty(authData)) {
        navigate("/login");
      }
    }
    setActiveContact(null);
  }, [user]);

  const createNewMail = (operator) => {
    chats.map((chat) => {
      if (chat.operators_id == operator.id) {
        setActiveOperator(operator);
        navigate("/chats/" + chat.id);
      }
    });
  };

  const banking_data = [
    {
      message: "Neue Email",
      chats_id: "16",
      tasks_id: "",
      files_id: "",
      users_id: "35",
      customers_id: "",
      automations_id: "0",
      sender: '"Asana" <learn@go.asana.com>',
      receiver: "info@exit925.de",
      thirdparty_id:
        "<1C.3E.33371.37E52086@i-09dc9bf4be0c4b9ea.mta1vrest.sd.prd.sparkpost>",
      automations_content: null,
      automations_status: "draft",
      seen: "0",
      status: "1",
      createdAt: "1744985715",
      thirdparty_createdAt: "0",
      notseencount: 0,
    },
    {
      message: "Neue Email",
      chats_id: "16",
      tasks_id: "",
      files_id: "",
      users_id: "35",
      customers_id: "",
      automations_id: "0",
      sender: '"Asana" <learn@go.asana.com>',
      receiver: "info@exit925.de",
      thirdparty_id:
        "<1C.3E.33371.37E52086@i-09dc9bf4be0c4b9ea.mta1vrest.sd.prd.sparkpost>",
      automations_content: null,
      automations_status: "draft",
      seen: "0",
      status: "1",
      createdAt: "1743985715",
      thirdparty_createdAt: "0",
      notseencount: 0,
    },
    {
      message: "Neue Email",
      chats_id: "16",
      tasks_id: "",
      files_id: "",
      users_id: "35",
      customers_id: "",
      automations_id: "0",
      sender: '"Asana" <learn@go.asana.com>',
      receiver: "info@exit925.de",
      thirdparty_id:
        "<1C.3E.33371.37E52086@i-09dc9bf4be0c4b9ea.mta1vrest.sd.prd.sparkpost>",
      automations_content: null,
      automations_status: "draft",
      seen: "0",
      status: "1",
      createdAt: "1742985715",
      thirdparty_createdAt: "0",
      notseencount: 0,
    },
  ];

  return (
    <div className="account">
      <div className="account_topnav">
        <div className="account_topnav_headline">Posteingang</div>
        <div className="home_topnav_menubtn" onClick={() => navigate("/menu")}>
          <MenuIcon />
        </div>
      </div>

      <div className="account_body">
        <div className="account_body_customers">
          {isEmpty(emailConnection) && (
            <div
              className="inbox_connectbtn"
              onClick={() => navigate("/connectemail")}>
              + Emailadresse verbinden
            </div>
          )}
          {!isEmpty(emailConnection) &&
            sortedData?.map((message, index) => (
              <div
                className="account_body_customers_element"
                key={"customers," + index}
                onClick={() => handleClick(message.chats_id, message.sender)}>
                <div className="account_body_customers_element_top">
                  <div className="account_body_customers_element_top_left">
                    {message.sender}
                  </div>
                  <div className="account_body_customers_element_top_right">
                    {formatTimestamp(message.createdAt)}
                  </div>
                </div>
                <div className="account_body_customers_element_bottom">
                  <div className="account_body_customers_element_bottom_left">
                    {message.message}
                  </div>
                  {message.seen == 1 || message.seen == "1" ? (
                    <div className="account_body_customers_element_bottom_right"></div>
                  ) : (
                    <div className="account_body_customers_element_bottom_right_active">
                      1
                    </div>
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 15x;
  color: #bababa;
`;

const CloudIcon = styled(MdFolder)`
  font-size: 18px;
  color: #474747;
`;

const CheckIcon = styled(MdCheckCircle)`
  font-size: 25px;
  color: #0072f5;
`;

const AddIcon = styled(MdAdd)`
  font-size: 23px;
  color: #0072f5;
`;

const FolderIcon = styled(MdFolder)`
  font-size: 23px;
  color: rgb(114, 114, 114);
`;

const AccountIcon = styled(MdPerson)`
  font-size: 23px;
  color: rgb(114, 114, 114);
`;
